module.exports = __webpack_public_path__ + "img/mi.70a9dbce.svg";